import { render, staticRenderFns } from "./KoneksiPoweredByOsigu.vue?vue&type=template&id=7141a84c&"
import script from "./KoneksiPoweredByOsigu.vue?vue&type=script&lang=js&"
export * from "./KoneksiPoweredByOsigu.vue?vue&type=script&lang=js&"
import style0 from "./KoneksiPoweredByOsigu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports